import styled from 'styled-components';

import { Link } from '../../../../components/Toolkit/Button/Link';
import { media } from '../../../../helpers/breakpoints';

const DoneDealMotorLink = styled(Link)`
  display: flex;
  align-items: center;
`;

const CertifiedTrustedDealerEntryPointCopy = styled.span`
  margin: ${({ theme }) => `0 ${theme.spacing.S2} 0 ${theme.spacing.S4}`};

  ${media.medium} {
    margin: ${({ theme }) => `0 ${theme.spacing.S4}`};
  }
`;

export { DoneDealMotorLink, CertifiedTrustedDealerEntryPointCopy };
